export default __webpack_public_path__ + "static/share-2945408a4d18a618eeb825d39063634f.jpg";